import React from 'react';
import { ITextInputProps } from './text-input';
import { useIntl } from 'react-intl';
import ToolTipAnchor from '../common/tooltip';
interface ITextInputBaseProps extends ITextInputProps {
    type: string;
}

const TextInputBase = ({
    type,
    innerRef,
    name,
    label,
    onChange,
    maxLength,
    placeholder,
    value,
    title,
    error,
    warning,
    showError,
    required,
    labelClassName,
    fieldClassName,
    elementClassName,
    groupAddOnBefore,
    groupAddOnAfter = '*',
    disabled,
    onBlur,
    onKeyDown,
    customLabel,
    toolTipMessage,
    isOldStyleRequired,
}: ITextInputBaseProps) => {
    const intl = useIntl();
    let wrapperClass = 'form-group';
    if (warning) {
        wrapperClass += ' has-warning';
    }
    if (error && error.length > 0) {
        wrapperClass += ' has-error';
    }

    const showGroupAddOnAfter = () => {
        return groupAddOnAfter !== '*';
    };

    return (
        <div className={wrapperClass}>
            {!customLabel ? (
                <label
                    className={
                        labelClassName
                            ? 'control-label ' + labelClassName
                            : 'control-label col-sm-4'
                    }
                    htmlFor={name}
                >
                    {label ? (
                        intl.formatMessage({
                            id: label.replace(/ /g, '_'),
                            defaultMessage: label,
                        })
                    ) : (
                        <></>
                    )}
                    {label ? ':' : ''}
                </label>
            ) : (
                <label
                    className={
                        labelClassName
                            ? 'control-label ' + labelClassName
                            : 'control-label col-sm-4'
                    }
                    htmlFor={name}
                    style={{ textTransform: 'none' }}
                >
                    {label ? (
                        intl.formatMessage({
                            id: label.replace(/ /g, '_'),
                            defaultMessage: label,
                        })
                    ) : (
                        <></>
                    )}{' '}
                    {required && (
                        <span
                            className="fas fa-asterisk required-red"
                            style={{ fontSize: '8px' }}
                        />
                    )}
                    {toolTipMessage && (
                        <ToolTipAnchor toolTipMessage={toolTipMessage} />
                    )}
                </label>
            )}
            <div
                className={
                    fieldClassName
                        ? 'field ' + fieldClassName
                        : 'field col-sm-8'
                }
            >
                <div
                    className={
                        (required && !isOldStyleRequired) ||
                        showGroupAddOnAfter() ||
                        customLabel
                            ? 'input-group'
                            : ''
                    }
                >
                    <input
                        ref={innerRef}
                        type={type}
                        onKeyDown={onKeyDown}
                        name={name}
                        className={
                            elementClassName
                                ? 'form-control ' + elementClassName
                                : 'form-control'
                        }
                        placeholder={placeholder}
                        maxLength={maxLength}
                        value={value}
                        title={title}
                        onChange={onChange}
                        disabled={disabled}
                        readOnly={disabled}
                        onBlur={onBlur}
                    />
                    {(required || showGroupAddOnAfter()) && !customLabel && (
                        <span
                            className={
                                isOldStyleRequired
                                    ? 'required'
                                    : 'input-group-addon'
                            }
                        >
                            {isOldStyleRequired ? undefined : groupAddOnAfter}
                        </span>
                    )}
                </div>
                {showError && error && (
                    <div className="alert alert-danger">{error}</div>
                )}
            </div>
        </div>
    );
};

export default TextInputBase;
